import type { Language } from "./content";
import type { MediaItem } from "./media";

export function initializeLightbox(items: MediaItem[]): void {
  const dialog = document.querySelector<HTMLDialogElement>("#media-dialog");
  const content = document.querySelector<HTMLElement>("#dialog-media");
  const caption = document.querySelector<HTMLElement>("#dialog-caption");
  const closeButton = document.querySelector<HTMLButtonElement>("#dialog-close");
  const previousButton = document.querySelector<HTMLButtonElement>("#dialog-previous");
  const nextButton = document.querySelector<HTMLButtonElement>("#dialog-next");
  if (!dialog || !content || !caption || !closeButton || !previousButton || !nextButton) return;

  let activeIndex = 0;
  let trigger: HTMLElement | null = null;

  const language = (): Language => (document.documentElement.lang === "uk" ? "uk" : "en");

  const render = (index: number): void => {
    activeIndex = (index + items.length) % items.length;
    const item = items[activeIndex];
    if (!item) return;
    const lang = language();
    content.innerHTML = item.type === "video"
      ? `<video src="${item.src}" poster="${item.poster}" controls playsinline aria-label="${item.alt[lang]}"></video>`
      : `<img src="${item.src}" alt="${item.alt[lang]}" width="${item.width}" height="${item.height}">`;
    caption.textContent = item.caption[lang];
  };

  const close = (): void => {
    content.querySelector("video")?.pause();
    dialog.close();
  };

  document.addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest<HTMLElement>("[data-media-index]");
    if (!button) return;
    trigger = button;
    render(Number(button.dataset.mediaIndex));
    document.documentElement.classList.add("dialog-open");
    dialog.showModal();
    closeButton.focus();
  });

  closeButton.addEventListener("click", close);
  previousButton.addEventListener("click", () => render(activeIndex - 1));
  nextButton.addEventListener("click", () => render(activeIndex + 1));

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) close();
  });

  dialog.addEventListener("close", () => {
    content.querySelector("video")?.pause();
    content.replaceChildren();
    document.documentElement.classList.remove("dialog-open");
    trigger?.focus();
  });

  window.addEventListener("parish-language-change", () => {
    if (dialog.open) render(activeIndex);
  });
}
